export default __webpack_public_path__ + "static/media/mill.a55e4e3c.ogg";